module.exports = __webpack_public_path__ + "img/edit.b77db8fb.svg";